const platformConfig = {
  campaign_status_codes: {
    0: { name: "Reporting not started", color_class: "light", percentage: "0", text_color: "dark" },
    1: { name: "Product Info updated", color_class: "productinfo", percentage: "20", text_color: "light" },
    2: { name: "Data Processed", color_class: "dataprocesses", percentage: "40", text_color: "light" },
    3: { name: "Visualisation done", color_class: "visualdone", percentage: "60", text_color: "light" },
    4: { name: "Data Extracted", color_class: "dataextracted", percentage: "80", text_color: "light" },
    5: { name: "Report Generated", color_class: "reportdone", percentage: "100", text_color: "light" },
  },
  assignee_values: [
    { value: "Nithin", label: "Nithin" },
    { value: "Anik", label: "Anik" },
    { value: "Jaya", label: "Jaya" },
    { value: "Shivani", label: "Shivani" },
  ],
  checkout_type_values: [
    { value: "Trolley+All", label: "Shoppers with trolley & all shoppers" },
    { value: "only-trolley", label: "All shoppers with trolley" },
    // {value:"basket_trolley","label":"Basket_trolley"},
    { value: "cap-counter", label: "All shoppers with a purchase at a C.A.P. counter" },
    // {value:"contact_cr","label":"Contact_cr"},
    { value: "detected-basket", label: "All shoppers with basket and passed a screen" },
    { value: "detected-basket_trolley", label: "All shoppers with trolley or basket and passed a screen" },
    { value: "detected-trolley", label: "All shoppers with trolley and passed a screen" },
    { value: "instore", label: "All shoppers with a purchase at an instore counter" },
    { value: "only-basket", label: "All shoppers with basket" },
    { value: "Only_trolley_basket", label: "All shoppers with trolley or basket" },
    { value: "All", label: "All" },
  ],
  finalized_checkout_vals: ["Trolley+All", "only-trolley", "All"],
  activity_types: [
    { value: "activity_1", label: "Discount" },
    { value: "activity_2", label: "Second Placement" },
    { value: "activity_3", label: "Public Event" },
    { value: "activity_4", label: "Other" },
    { value: "add_manually", label: "Add Manually" },
  ],
  campaign_status_codes_new: {
    0: { name: "Reporting not started", color_class: "light", percentage: "0", text_color: "dark" },
    1: { name: "Product Info updated", color_class: "productinfo", percentage: "20", text_color: "light" },
    2: { name: "ETL Activated", color_class: "dataprocesses", percentage: "40", text_color: "light" },
    3: { name: "Data Processed", color_class: "dataextracted", percentage: "60", text_color: "light" },
    4: { name: "Visuals Generated", color_class: "visualdone", percentage: "80", text_color: "light" },
  },
  initial_load_count: 10,
  required_dates_for_reporting: 7,
  valid_file_types_for_pictures: ["image/jpeg", "image/png", "image/jpg", "video/mp4"],
  valid_file_types_for_clips: ["video/mp4"],
  valid_file_types_for_pictures_withExtention: [".jpeg", ".png", ".jpg", ".mp4"],
  valid_file_types_for_clips_withExtention: [".mp4"],
  valid_file_types: [
    "image/jpeg",
    "image/png",
    "image/gif",
    "image/bmp",
    "image/webp",
    "video/mp4",
    "video/webm",
    "video/ogg",
  ],
  timezone: "Europe/Berlin",
  hour_values: [
    "00:00",
    "00:05",
    "00:15",
    "00:30",
    "00:45",
    "01:00",
    "01:15",
    "01:30",
    "01:45",
    "02:00",
    "02:15",
    "02:30",
    "02:45",
    "03:00",
    "03:15",
    "03:30",
    "03:45",
    "04:00",
    "04:15",
    "04:30",
    "04:45",
    "05:00",
    "05:15",
    "05:30",
    "05:45",
    "06:00",
    "06:15",
    "06:30",
    "06:45",
    "07:00",
    "07:15",
    "07:30",
    "07:45",
    "08:00",
    "08:15",
    "08:30",
    "08:45",
    "09:00",
    "09:15",
    "09:30",
    "09:45",
    "10:00",
    "10:15",
    "10:30",
    "10:45",
    "11:00",
    "11:15",
    "11:30",
    "11:45",
    "12:00",
    "12:15",
    "12:30",
    "12:45",
    "13:00",
    "13:15",
    "13:30",
    "13:45",
    "14:00",
    "14:15",
    "14:30",
    "14:45",
    "15:00",
    "15:15",
    "15:30",
    "15:45",
    "16:00",
    "16:15",
    "16:30",
    "16:45",
    "17:00",
    "17:15",
    "17:30",
    "17:45",
    "18:00",
    "18:15",
    "18:30",
    "18:45",
    "19:00",
    "19:15",
    "19:30",
    "19:45",
    "20:00",
    "20:15",
    "20:30",
    "20:45",
    "21:00",
    "21:15",
    "21:30",
    "21:45",
    "22:00",
    "22:15",
    "22:30",
    "22:45",
    "23:00",
    "23:15",
    "23:30",
    "23:45",
    "23:50",
  ],
  availableToUserTypes: ["cyreen", "national", "branch"],
  embeddable_filter_config: {
    "overview": {
      "landing_page_overview_filter": {
        "master": true,
        92: false
      },
    }
  },
  embeddable_config: {
    "overview": {
      "landing_page_overview": [73, 92],
    },
    "brand_analytics": {
      "campaign_overview": [73],
      "clip_overview": [],
      "loop_overview": [],
      "campaign_analytics": [76, 73]
    },
    "retail_analytics": {
      "general_kpi": [76],
      "instore_duration": [76],
      "profitability": [76],
      "trolley_usage": [76],
      "heatmap": [76],
      "optimization": [76],
    },
    "infrastructure": {
      "status_monitoring": [73, 71],
      "live_monitoring": [73, 71],
      "total_monitoring": [73, 71],
      "store_monitoring": [73, 71],
      "receipt_monitoring": [73, 71],
    }
  },
  embeddable_dashboards: {
    "overview": {
      "landing_page_overview": {
        "master": "66f37624-8e89-40fd-a5fb-a3f4194522a5",
        73: "63e3bc63-b2d1-4bf2-b208-0fc3f3f8e8f6",
        92: "21f9af6d-3d09-45f4-bf5e-1e94d5a5327e"
      }
    },
    "brand_analytics": {
      "campaign_overview": {
        73: "feb49b26-8502-4fb1-a7d1-398c22820cc4",
        "master": "38f4cda5-08ee-4275-b251-dbc2b8947324",
      },
      "clip_overview": {
        "master": "6dc31caa-40d6-4da1-86c3-98ae43819a17"
      },
      "loop_overview": {
        "master": "2c4ec4e9-d495-4496-9ac4-9cccc52c83d5"
      },
      "campaign_analytics": {
        "master": "83d61fdd-4932-43bb-a3b0-7d88d5b13c5f",
        76: "b97dd5bb-de29-4160-82f6-0e3220b254a5",
        73: "e5d7286a-024e-4e9c-ac9a-3e6214db6547",
      }
    },
    "retail_analytics": {
      "general_kpi": {
        "master": "85953fc5-ba37-40b2-8972-832af23aa327",
        76: "e456944c-f282-44d1-ace4-9f9a3ab7a9e6",
      },
      "instore_duration": {
        "master": "1038b255-2831-42d8-9f57-d53ba31a0d5e",
        76: "b34695c8-75d3-49a0-bea1-f3c0c9d7a3e1",
      },
      "profitability": {
        76: "5638e95a-08a8-4826-a51b-20a3b2b01323",
        "master": "b5aac6de-ee50-4cca-abb0-a948b9174058",
      },
      "trolley_usage": {
        76: "7344cbb6-3cf8-4cb3-8dcc-a046554c343e",
        "master": "9211b2c9-1843-4d90-99bf-b86a5d8bafee",
      },
      "heatmap": {
        76: "b63abe8f-7d0f-4754-94bf-d5bd020d9484",
        "master": "b63abe8f-7d0f-4754-94bf-d5bd020d9484",
      },
      "optimization": {
        76: "2abfab76-cc68-456a-9f9a-cc478b51fcdc",
        "master": "d6f970af-6c60-4eef-8f9b-ea86e077b19f",
      }
    },
    "infrastructure": {
      "status_monitoring": {
        73: "c548fd77-47e7-4e6c-a2ab-d1a99a5f7a40",
        71: "c548fd77-47e7-4e6c-a2ab-d1a99a5f7a40",
        "master": "c548fd77-47e7-4e6c-a2ab-d1a99a5f7a40",
      },
      "total_monitoring": {
        73: "bc9a6896-e13f-4aa2-a490-592cdb40cef5",
        71: "2262b9e9-2ca1-4901-9c77-23e28d7665d8",
        "master": "abb563d0-efc9-4020-ac62-8f0c2d8dff81",
      },
      "store_monitoring": {
        73: "620ad5c6-d8f5-4358-bd66-d0595359cf10",
        71: "4d0aca2c-21c3-4301-a556-17566bf807d3",
        "master": "7ba649a5-92ad-4ac1-ae8a-7ec61e7b9a53",
      },
      "receipt_monitoring": {
        73: "921a4675-7921-4bcb-8008-b22a96961e20",
        71: "921a4675-7921-4bcb-8008-b22a96961e20",
        "master": "921a4675-7921-4bcb-8008-b22a96961e20",
      },
    }
  },
  tenantSelectionAvailableFor: ["cyreen", "tenant", "agency"],
  retailerSelectionAvailableFor: ["cyreen", "tenant", "agency"],
  retailAnalyticsAvailableFor: ["cyreen", "branch", "store", "tenant"],
};

export default platformConfig;

